import AnzLogo from '../assets/logo/anz/logo-anz-blue-flat.png';
import { createPaletteColourVariations, createTheme } from './theme';
import { ITheme, IThemeColourPalette } from './interfaces';

export const anzLightPalette: IThemeColourPalette = {
  primary: {
    first: '#007DBA',
    second: '#007DBA',
    text: '#000'
  },
  secondary: {
    first: '#004165',
    second: '#004165',
    third: '#004165'
  },
  neutral: {
    // same as CMC
    black: '#000',
    gray: '#ECEFF0',
    white: '#fff'
  },
  alerts: {
    success: '#54FABB', // same as CMC
    pending: '#FFC405', // same as CMC
    alert: '#EE2F53' // same as CMC
  },
  // Temporary, until UX reviews the colors
  trading: {
    up: '#28BE24',
    down: '#FF0101',
    buy: '#18A0FB',
    sell: '#FFC405'
  }
};

export const anzDarkPalette: IThemeColourPalette = JSON.parse(JSON.stringify(anzLightPalette));

anzDarkPalette.primary.first = '#cdd0d5';
anzDarkPalette.primary.text = '#fff';
anzDarkPalette.neutral.black = '#fff';
anzDarkPalette.neutral.white = '#000';

// TODO update with ANZ logo
export const themeAnzLight: ITheme = createTheme('anz.light', anzLightPalette, { normal: AnzLogo, inverted: AnzLogo });
export const themeAnzDark: ITheme = createTheme('anz.dark', anzDarkPalette, { normal: AnzLogo, inverted: AnzLogo });

// for storybook mdx
export const lightPalette = createPaletteColourVariations(anzLightPalette, anzLightPalette.neutral.white);
export const darkPalette = createPaletteColourVariations(anzDarkPalette, anzDarkPalette.neutral.white);
